import React from "react";
import Header from "../../components/HeaderGreen";
import Footer from "../../components/Footer";
import AboutBanner from "../../components/AboutBanner";
import ContactSection from "../../components/ContactSection";
import ServicesSection from "../../components/Services/ServicesSection";
import EndToEndSolutions from "../../components/About/EndToEndSolutions";

function Home() {
  return (
    <>
      <Header />
      <AboutBanner
  title="Service Offering"
subtitle="☀️ CM Green Energy India Private Limited"
/>
      <ServicesSection />
      <EndToEndSolutions />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
